import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { GzFormFieldToggleableWebComponent, GzFormFieldWebComponent } from '../../../ui/gzForm/formField';
import { GzInputNumberWebComponent } from '../../../ui/gzInput';
import { GzToggleWebComponent } from '../../../ui/gzToggle';
import { GzDropdownWebComponent } from '../../../ui/gzDropdown';
import { FormGroup } from '../../../ui/gzForm/formGroup/form-group';
import { RequiredValidator } from '../../../ui/gzForm/validators/required.validator';
import { MinValidator } from '../../../ui/gzForm/validators/min.validator';
import { GzHardCodedFormField } from '../../../ui/gzForm/formField/component/GzHardCodedFormField';
import { CompanyLicenseInformation } from '../../types/CompanyLicenseInformation';
import { MaxValidator } from '../../../ui/gzForm/validators/max.validator';
import { LicenseMainFormViewData } from '../../licenseMainForm/types/LicenseMainFormViewData';
import { CompanyActionContext } from '../../../company/common/types/CompanyActionContext';
import _, { upperCase } from 'lodash';
import { SelectOption } from '../../../ui/gzDropdown/types';
import { WhitelistValidator } from '../../../ui/gzForm/validators/whitelist.validator';
import { toggleVisibility } from '../../../utils/htmlElement.utils';
import { GzDatePickerWebComponent } from '../../../ui/gzDatePicker';
import moment from 'moment/moment';
import { LicenseConstants } from '../../LicenseConstants';
import { MonthlyProductType } from '../../types/MonthlyProductType';
import { GzAccordionWebComponent } from '../../../ui/gzAccordion';
import { LicenseMonthlyServicesFormWebComponent } from '../../common/servicesForm';
import { LicenseMonthlyAddonsFormWebComponent } from '../../common/addonsForm';
import { GzTextWebComponent } from '../../../ui/gzText';
import { getLocalizedAsset } from '../../../utils/i18n.utils';
import { BaseWebComponentTranslator } from '../../../framework/BaseWebComponentTranslator';
import { CompanyData, CompanyFeatures, ProductService } from '../../../company/types/company-data';
import { Feature, FeatureFlag } from '@nirvana/shared/constants';
import { DeepPartial } from 'typeorm';
import { FormGroupValue } from '../../../ui/gzForm/formGroup/types/form-group-value';
import { MenuPosition } from '../../../types/common/types';
import { ProductTypeInformation } from '../../types/ProductTypeInformation';
import { getAvailableProductTypes, getSubscriptionFormEndDateMinValue } from '../../common/licenseHelper';
import { htmlEncode } from '../../../utils/escape.utils';
import { AddonFormType } from '../../common/addonsForm/types/AddonFormType';
import { GzDialogWebComponent } from '../../../ui/gzDialog';
import { LicenseMonthlyOwnBundleFormWebComponent } from '../../common/ownBundleForm';
import { LicenseMonthlyResellBundleFormWebComponent } from '../../common/resellBundleForm';
import {
  WEB_COMPONENT_GZ_RADIO,
  WEB_COMPONENT_GZ_TOGGLE,
  WEB_COMPONENT_LICENSE_MONTHLY_BUNDLE_FORM,
  WEB_COMPONENT_LICENSE_MONTHLY_RESELL_BUNDLE_FORM,
} from '../../../webcomponents.constants';
import getUpdatedUsableBundlesFeatures = Feature.getUpdatedUsableBundlesFeatures;
import getUsableBundleFeature = Feature.getUsableBundleFeature;
import getResellBundleFeatures = Feature.getResellBundleFeatures;
import { LicenseType } from '../../types/LicenseType';
import { LicenseProductIdEnum } from '@nirvana/shared/license-helper';
import { Bundle } from '../../types/Bundles';

export class LicenseMonthlySubscriptionSubFormView extends BaseWebComponentView {
  private translator: BaseWebComponentTranslator;

  public formGroup: FormGroup;
  public viewData?: LicenseMainFormViewData;
  public companionUsableToggle = new GzHardCodedFormField<boolean>(false);
  public mdrDelegateFormField = new GzHardCodedFormField<boolean>(false);
  private agreeRemoveReservedSlotsForChildren = false;

  public dom: {
    $wrapper: HTMLElement;

    $subscriptionDetailsAccordion: GzAccordionWebComponent;
    $subscriptionPreferencesLabel: GzTextWebComponent;

    $reserveSeatsFormField: GzFormFieldToggleableWebComponent<GzInputNumberWebComponent, number>;
    $availableSeatsText: GzTextWebComponent;

    $subscriptionEndDateFormField: GzFormFieldToggleableWebComponent<GzDatePickerWebComponent, number>;
    $subscriptionEndDateText: GzTextWebComponent;

    $autoRenewalFormField: GzFormFieldToggleableWebComponent<GzInputNumberWebComponent, number>;
    $autoRenewalText: GzTextWebComponent;

    $minimumUsageFormField: GzFormFieldToggleableWebComponent<GzInputNumberWebComponent, number>;
    $minimumUsageText: GzTextWebComponent;

    $ownUseAccordion: GzAccordionWebComponent;

    ownUseProductInformation: {
      endpointSecurityInformation: ProductTypeInformation;
      bitdefenderEdrInformation: ProductTypeInformation;
    };

    $ownUseProductTypeFormField: GzFormFieldWebComponent<GzDropdownWebComponent, string | number>;

    $ownUseBundlesSection: HTMLElement;

    $ownUseAddonsSection: HTMLElement;
    $ownUseAddonsInfo: ProductTypeInformation;
    $ownUseAddonsLabel: HTMLElement;
    $ownUseMonthlyAddonsForm: LicenseMonthlyAddonsFormWebComponent;

    $ownUseServicesSection: HTMLElement;
    $ownUseServicesInfo: ProductTypeInformation;
    $ownUseServicesLabel: HTMLElement;
    $ownUseMonthlyServicesForm: LicenseMonthlyServicesFormWebComponent;
    $ownUseBundleForm: LicenseMonthlyOwnBundleFormWebComponent;
    $ownUseBundlesTitle: GzTextWebComponent;
    $resellBundleForm: LicenseMonthlyResellBundleFormWebComponent;

    $resellingAccordion: GzAccordionWebComponent;

    resellingProductInformation: {
      endpointSecurityInformation: ProductTypeInformation;
      bitdefenderEdrInformation: ProductTypeInformation;
    };

    $resellingProductsSection: HTMLElement;

    $resellingProductTypeInfo: HTMLElement;
    $resellingProductTypeLabel: HTMLElement;
    $resellingProductEndpointSecurityToggle: GzFormFieldWebComponent<GzToggleWebComponent, boolean>;
    $resellingProductBitdefenderEdrToggle: GzFormFieldWebComponent<GzToggleWebComponent, boolean>;

    $resellingBundlesSection: HTMLElement;
    $resellingBundlesTitle: HTMLElement;
    $resellingAddonsSection: HTMLElement;
    $resellingAddonsInfo: ProductTypeInformation;
    $resellingAddonsLabel: HTMLElement;
    $resellingMonthlyAddonsForm: LicenseMonthlyAddonsFormWebComponent;

    $resellingServicesSection: HTMLElement;
    $resellingServicesInfo: ProductTypeInformation;
    $resellingMdrLabel: HTMLElement;
    $resellingMdrFormField: GzFormFieldWebComponent<GzToggleWebComponent, boolean>;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('#wrapper'),

      $subscriptionDetailsAccordion: this.shadow.querySelector('#subscription-details-section'),
      $subscriptionPreferencesLabel: this.shadow.querySelector('#subscription-preferences-label'),

      $reserveSeatsFormField: this.shadow.querySelector('#reserve-seats-form-field'),
      $availableSeatsText: this.shadow.querySelector('#available-seats-text'),

      $subscriptionEndDateFormField: this.shadow.querySelector('#add-subscription-end-date-form-field'),
      $subscriptionEndDateText: this.shadow.querySelector('#add-subscription-end-date-text'),

      $autoRenewalFormField: this.shadow.querySelector('#set-auto-renewal-form-field'),
      $autoRenewalText: this.shadow.querySelector('#set-auto-renewal-text'),

      $minimumUsageFormField: this.shadow.querySelector('#minimum-usage-form-field'),
      $minimumUsageText: this.shadow.querySelector('#minimum-usage-text'),

      $ownUseAccordion: this.shadow.querySelector('#own-use-section'),

      ownUseProductInformation: {
        endpointSecurityInformation: {
          $infoText: this.shadow.querySelector('#own-use-product-details-endpoint-security-text'),
          $link: this.shadow.querySelector('#own-use-product-details-endpoint-security-link'),
        },
        bitdefenderEdrInformation: {
          $infoText: this.shadow.querySelector('#own-use-product-details-bitdefender-edr-text'),
          $link: this.shadow.querySelector('#own-use-product-details-bitdefender-edr-link'),
        },
      },

      $ownUseProductTypeFormField: this.shadow.querySelector('#own-use-product-type-form-field'),

      $ownUseBundlesSection: this.shadow.querySelector('#own-use-bundles-section'),
      $ownUseBundlesTitle: this.shadow.querySelector('#own-use-bundle-title'),
      $ownUseBundleForm: this.shadow.querySelector(WEB_COMPONENT_LICENSE_MONTHLY_BUNDLE_FORM),
      $resellBundleForm: this.shadow.querySelector(WEB_COMPONENT_LICENSE_MONTHLY_RESELL_BUNDLE_FORM),

      $ownUseAddonsSection: this.shadow.querySelector('#own-use-addons-section'),
      $ownUseAddonsInfo: {
        $infoText: this.shadow.querySelector('#own-use-addons-details-text'),
        $link: this.shadow.querySelector('#own-use-addons-details-link'),
      },
      $ownUseAddonsLabel: this.shadow.querySelector('#own-use-addons-label'),
      $ownUseMonthlyAddonsForm: this.shadow.querySelector('#own-use-addons-form'),

      $ownUseServicesSection: this.shadow.querySelector('#own-use-services-section'),
      $ownUseServicesInfo: {
        $infoText: this.shadow.querySelector('#own-use-services-details-text'),
        $link: this.shadow.querySelector('#own-use-services-details-link'),
      },
      $ownUseServicesLabel: this.shadow.querySelector('#own-use-services-label'),
      $ownUseMonthlyServicesForm: this.shadow.querySelector('#own-use-services-form'),

      $resellingAccordion: this.shadow.querySelector('#reselling-section'),

      resellingProductInformation: {
        endpointSecurityInformation: {
          $infoText: this.shadow.querySelector('#reselling-product-details-endpoint-security-text'),
          $link: this.shadow.querySelector('#reselling-product-details-endpoint-security-link'),
        },
        bitdefenderEdrInformation: {
          $infoText: this.shadow.querySelector('#reselling-product-details-bitdefender-edr-text'),
          $link: this.shadow.querySelector('#reselling-product-details-bitdefender-edr-link'),
        },
      },

      $resellingProductsSection: this.shadow.querySelector('#reselling-product-section'),
      $resellingProductTypeInfo: this.shadow.querySelector('#reselling-product-type-details'),
      $resellingProductTypeLabel: this.shadow.querySelector('#reselling-product-type-label'),
      $resellingProductEndpointSecurityToggle: this.shadow.querySelector('#reselling-product-es-toggle-form-field'),
      $resellingProductBitdefenderEdrToggle: this.shadow.querySelector('#reselling-product-edr-toggle-form-field'),

      $resellingBundlesSection: this.shadow.querySelector('#reselling-bundles-section'),
      $resellingBundlesTitle: this.shadow.querySelector('#resell-bundle-title'),

      $resellingAddonsSection: this.shadow.querySelector('#reselling-addons-section'),
      $resellingAddonsInfo: {
        $infoText: this.shadow.querySelector('#reselling-addons-details-text'),
        $link: this.shadow.querySelector('#reselling-addons-details-link'),
      },
      $resellingAddonsLabel: this.shadow.querySelector('#reselling-addons-label'),
      $resellingMonthlyAddonsForm: this.shadow.querySelector('#reselling-addons-form'),

      $resellingServicesSection: this.shadow.querySelector('#reselling-services-section'),
      $resellingServicesInfo: {
        $infoText: this.shadow.querySelector('#reselling-services-details-text'),
        $link: this.shadow.querySelector('#reselling-services-details-link'),
      },
      $resellingMdrLabel: this.shadow.querySelector('#reselling-mdr-services-label'),
      $resellingMdrFormField: this.shadow.querySelector('#reselling-mdr-services-form-field'),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.translator = BaseWebComponentTranslator.getInstance();
    this.translations = this.stringsTranslator.getMdrTranslations();

    return this.translations;
  }

  setTranslatedStrings() {
    const learnMoreTranslation = `<span>${htmlEncode(this.dependencies.translateFn('Learn more'))}</span>`;
    const modulesInfoText = this.dependencies.translateFn(
      'Each add-on or service has a fee based on usage. Enabling the add-on or service will add the fee to your monthly subscription. You can view the usage details in the Monthly License Usage report.'
    );
    const learnMoreUsage = `<span>${htmlEncode(
      this.dependencies.translateFn('Learn how to calculate the monthly usage')
    )}</span>`;

    this.dom.$subscriptionDetailsAccordion.accordionTitle = upperCase(this.dependencies.translateFn('Subscription details'));
    this.dom.$subscriptionPreferencesLabel.innerText = this.dependencies.translateFn('Subscription preferences');

    this.dom.$reserveSeatsFormField.label = this.dependencies.translateFn('Reserve seats');

    this.dom.$subscriptionEndDateFormField.label = this.dependencies.translateFn('Add subscription end date');
    this.dom.$subscriptionEndDateFormField.Input.placeholder = this.dependencies.translateFn('day/month/year');
    this.dom.$subscriptionEndDateText.innerHTML = this.dependencies.translateFn(
      'After reaching the subscription end date, the company is suspended and the endpoints expire, unless auto-renewal is enabled.'
    );

    this.dom.$autoRenewalFormField.label = this.dependencies.translateFn('Set auto-renewal');
    this.dom.$autoRenewalText.innerHTML = this.dependencies.translateFn(
      'This option automatically extends the subscription validity by the number of months specified in the corresponding box.'
    );

    this.dom.$minimumUsageFormField.label = this.dependencies.translateFn('Select minimum usage');
    this.dom.$minimumUsageText.innerHTML = this.dependencies.translateFn(
      'The minimum number of endpoints that this company has committed to use on a monthly basis.'
    );

    this.dom.$ownUseAccordion.accordionTitle = upperCase(this.dependencies.translateFn('Products for own use'));

    this.dom.ownUseProductInformation.endpointSecurityInformation.$infoText.innerText = this.dependencies.translateFn(
      'With {endpointSecurityProductType}, the company can access all features and add-ons available for {cloudSecurityMspProductName}.',
      {
        endpointSecurityProductType: this.stringsTranslator.getMonthlyProductType(MonthlyProductType.EndpointSecurity),
        cloudSecurityMspProductName: this.stringsTranslator.translateProductId(LicenseProductIdEnum.ProductIdMsp),
      }
    );
    this.dom.ownUseProductInformation.endpointSecurityInformation.$link.innerHTML = learnMoreTranslation;
    this.dom.ownUseProductInformation.endpointSecurityInformation.$link.href = getLocalizedAsset<string>(
      LicenseConstants.InfoLinks.CloudSecurityMsp,
      this.dependencies.getUserLanguage()
    );
    this.dom.ownUseProductInformation.bitdefenderEdrInformation.$infoText.innerText = this.dependencies.translateFn(
      '{bitdefenderEdrProductType} monitors the company`s network to early uncover suspicious activity, and provides the tools to fight-off cyber-attacks. It is suited to coexist with an endpoint security solution from a different vendor.',
      {
        bitdefenderEdrProductType: this.stringsTranslator.getMonthlyProductType(MonthlyProductType.BitdefenderEdr),
      }
    );
    this.dom.ownUseProductInformation.bitdefenderEdrInformation.$link.innerHTML = learnMoreTranslation;
    this.dom.ownUseProductInformation.bitdefenderEdrInformation.$link.href = LicenseConstants.InfoLinks.BitdefenderEdr;

    this.dom.$ownUseProductTypeFormField.label = this.dependencies.translateFn('Select product type');

    this.dom.$ownUseAddonsInfo.$infoText.textContent = modulesInfoText;
    this.dom.$ownUseAddonsInfo.$link.innerHTML = learnMoreUsage;
    this.dom.$ownUseAddonsInfo.$link.href = LicenseConstants.InfoLinks.HowToCalculateMonthlyUsage;
    this.dom.$ownUseAddonsLabel.innerText = this.dependencies.translateFn('Add-ons');

    this.dom.$ownUseServicesInfo.$infoText.textContent = this.translations.mdrInfoText;
    this.dom.$ownUseServicesInfo.$link.innerHTML = this.translations.learnMoreMdr;
    this.dom.$ownUseServicesInfo.$link.href = LicenseConstants.InfoLinks.MdrServiceFaq;
    this.dom.$ownUseServicesLabel.innerText = this.dependencies.translateFn('Services');

    this.dom.$resellingAccordion.accordionTitle = upperCase(this.dependencies.translateFn('Products for reselling'));

    this.dom.$resellingProductTypeInfo.innerText = this.dependencies.translateFn(
      'The partner company can assign to its client companies the following Bitdefender product types.'
    );

    this.dom.resellingProductInformation.endpointSecurityInformation.$infoText.innerText =
      this.dependencies.translateFn(
        'With {endpointSecurityProductType}, the company can access all features and add-ons available for {cloudSecurityMspProductName}.',
        {
          endpointSecurityProductType: this.stringsTranslator.getMonthlyProductType(
            MonthlyProductType.EndpointSecurity
          ),
          cloudSecurityMspProductName: this.stringsTranslator.translateProductId(LicenseProductIdEnum.ProductIdMsp),
        }
      );
    this.dom.resellingProductInformation.endpointSecurityInformation.$link.innerHTML = learnMoreTranslation;
    this.dom.resellingProductInformation.endpointSecurityInformation.$link.href = getLocalizedAsset<string>(
      LicenseConstants.InfoLinks.CloudSecurityMsp,
      this.dependencies.getUserLanguage()
    );
    this.dom.resellingProductInformation.bitdefenderEdrInformation.$infoText.innerText = this.dependencies.translateFn(
      'Bitdefender EDR monitors the company`s network to early uncover suspicious activity, and provides the tools to fight-off cyber-attacks. It is suited to coexist with an endpoint security solution from a different vendor.'
    );
    this.dom.resellingProductInformation.bitdefenderEdrInformation.$link.innerHTML = learnMoreTranslation;
    this.dom.resellingProductInformation.bitdefenderEdrInformation.$link.href =
      LicenseConstants.InfoLinks.BitdefenderEdr;

    this.dom.$resellingProductTypeLabel.innerText = this.dependencies.translateFn('Products to resell');
    this.dom.$resellingProductBitdefenderEdrToggle.Input.textContent = 'Bitdefender EDR';
    this.dom.$resellingProductEndpointSecurityToggle.Input.textContent = 'Endpoint security';

    this.dom.$resellingAddonsInfo.$infoText.textContent = modulesInfoText;
    this.dom.$resellingAddonsInfo.$link.innerHTML = learnMoreUsage;
    this.dom.$resellingAddonsInfo.$link.href = LicenseConstants.InfoLinks.HowToCalculateMonthlyUsage;
    this.dom.$resellingAddonsLabel.innerText = this.dependencies.translateFn('Add-ons');

    this.dom.$resellingServicesInfo.$infoText.textContent = this.translations.mdrInfoText;
    this.dom.$resellingServicesInfo.$link.innerHTML = this.translations.learnMoreMdr;
    this.dom.$resellingServicesInfo.$link.href = LicenseConstants.InfoLinks.MdrServiceFaq;
    this.dom.$resellingMdrLabel.innerText = this.dependencies.translateFn('Services');
    this.dom.$resellingMdrFormField.Input.textContent = this.translations.resellingMdr;

    this.dom.$ownUseBundlesTitle.innerText = this.dependencies.translateFn('Select protection model');
    this.dom.$resellingBundlesTitle.innerText = this.dependencies.translateFn('Select protection model');
  }

  public getFormValue(): FormGroupValue {
    const value = _.clone(this.formGroup.value);

    const endDateIsOn = this.dom.$subscriptionEndDateFormField.isOn;
    const autoRenewalIsOn = this.dom.$autoRenewalFormField.isOn;
    const minimumUsageIsOn = this.dom.$minimumUsageFormField.isOn;
    const updatedUsableBundleFeatures = getUpdatedUsableBundlesFeatures(this.dom.$ownUseBundleForm.value);
    const updatedResellBundleFeatures = this.dom.$resellBundleForm.value;

    const unixEndDate: number | undefined = _.get(
      value,
      ['specifics', 'license', 'endSubscription', 'endDate'],
      undefined
    );
    const features: CompanyFeatures = _.get(value, ['specifics', 'features'], {});

    if (unixEndDate) {
      // set endDate field
      const endDate = moment(new Date(unixEndDate * 1000)).format('YYYY-MM-DD');
      _.set(value, ['specifics', 'license', 'endSubscription', 'endDate'], endDate);
    } else {
      _.set(value, ['specifics', 'license', 'endSubscription', 'endDate'], undefined);
    }

    _.set(value, ['specifics', 'license', 'endSubscription', 'endDateIsSet'], endDateIsOn);
    _.set(value, ['specifics', 'license', 'endSubscription', 'autoRenewPeriodIsSet'], autoRenewalIsOn);
    _.set(value, ['specifics', 'minimalCommitment', 'usage', 'endpointsIsSet'], minimumUsageIsOn);

    _.set(
      value,
      ['specifics', 'features'],
      _.merge(
        features,
        this.dom.$ownUseMonthlyAddonsForm.value,
        this.dom.$resellingMonthlyAddonsForm.value,
        this.dom.$ownUseMonthlyServicesForm.value,
        updatedUsableBundleFeatures,
        updatedResellBundleFeatures
      )
    );

    // adapt to format required by CompanyData
    _.set(value, ['specifics', 'licenses'], [_.get(value, ['specifics', 'license'])]);
    _.unset(value, ['specifics', 'license']);

    // set agreeRemoveReservedSlotsForChildren flag depending by the user response to warning dialog
    _.set(value, ['specifics', 'agreeRemoveReservedSlotsForChildren'], this.agreeRemoveReservedSlotsForChildren);

    return value;
  }

  public setViewData(viewData: LicenseMainFormViewData) {
    // view data already set, skip
    if (this.viewData) {
      this.updateViewData(viewData);
      return;
    }

    this.createFormGroup();
    this.updateViewData(viewData);
  }

  public setCompanyData(company: CompanyData) {
    const clonedCompany = _.cloneDeep(company);

    const monthlyLicense = CompanyData.getMonthlyLicense(clonedCompany);
    if (monthlyLicense?.endSubscription?.endDate) {
      const timezone = this.dependencies.getTimezone();
      monthlyLicense.endSubscription.endDate = moment(monthlyLicense.endSubscription.endDate)
        .tz(timezone)
        .format('YYYY-MM-DD');
    }

    this.setSubscriptionDetails(clonedCompany);
    this.setProductsAndServices(clonedCompany.specifics.features, clonedCompany.specifics.productServices);

    this.setUpReserveSeatsFormField();
  }

  public setSubscriptionDetails(company: DeepPartial<CompanyData>) {
    const license = CompanyData.getFirstBaseLicense(company);

    if (!license) {
      throw new Error('setSubscriptionDetails: company does not have license');
    }

    // extract only relevant fields from company
    const subscriptionDetails = {
      specifics: {
        hasReservedSlots: !!company.specifics?.hasReservedSlots,
        license: {
          endSubscription: {
            endDate: license.endSubscription?.endDate,
            endDateIsSet: !!license.endSubscription?.endDateIsSet,
            autoRenewPeriod: license.endSubscription?.autoRenewPeriod,
            autoRenewPeriodIsSet: !!license.endSubscription?.autoRenewPeriodIsSet,
          },
          total: license.total,
        },
        minimalCommitment: {
          usage: {
            endpoints: company.specifics?.minimalCommitment?.usage?.endpoints,
            endpointsIsSet: !!company.specifics?.minimalCommitment?.usage?.endpointsIsSet,
          },
        },
      },
    };

    // load subscription details into form
    this.formGroup.value = subscriptionDetails;

    if (!subscriptionDetails.specifics?.hasReservedSlots) {
      // if there are no reserved seats, the license.total field is not set so the 'value' setter does not overwrite the form value
      this.dom.$reserveSeatsFormField.setValueWithoutToggleUpdate(
        LicenseConstants.MonthlySubscription.ReserveSeats.Default
      );
      this.dom.$reserveSeatsFormField.setToggleFormValue(false);
    }

    const endSubscription = subscriptionDetails.specifics.license.endSubscription;
    const hasEndSubscriptionDateSet = endSubscription?.endDateIsSet ?? false;

    if (!endSubscription?.endDateIsSet) {
      // End subscription may be inherited. In this case, we have a valid endDate (the inherited one) but endDateIsSet is false.
      this.dom.$subscriptionEndDateFormField.value = undefined;
      this.dom.$subscriptionEndDateFormField.setToggleFormValue(false);
    } else {
      const endDate = endSubscription.endDate;

      this.dom.$subscriptionEndDateFormField.value = endDate ? moment(endDate).unix() : 0;
      this.dom.$subscriptionEndDateFormField.validate();
    }

    if (!endSubscription?.autoRenewPeriodIsSet) {
      // Auto renewal period may be inherited. In this case, we have a valid period (the inherited one) but autoRenewPeriodIsSet is false.
      this.dom.$autoRenewalFormField.value = LicenseConstants.MonthlySubscription.AutoRenewal.Default;
      this.dom.$autoRenewalFormField.setToggleFormValue(false);
    }

    this.dom.$autoRenewalFormField.disabled = !hasEndSubscriptionDateSet;
    this.dom.$autoRenewalFormField.touched = true;

    if (!subscriptionDetails.specifics.minimalCommitment.usage.endpointsIsSet) {
      // if minimum usage is not set, the specifics.minimalCommitment field is set to undefined on the company record
      // which comes from the backend
      this.dom.$minimumUsageFormField.value = LicenseConstants.MonthlySubscription.MinimumUsage.Default;
      this.dom.$minimumUsageFormField.setToggleFormValue(false);
    }
  }

  public createMdrDialog(
    dialogConfirmCallback: () => void,
    dialogCancellationCallback: () => void
  ): GzDialogWebComponent {
    const bodyText = this.dependencies.translateFn(
      'The setting below needs to be enabled before activating the MDR service:<br><b>Your Bitdefender partner can assist you with security management.</b>'
    );
    const dialogBody = `<p>${bodyText}</p>`;

    const confirmationButtonText = this.dependencies.translateFn('Enable');

    const dialogFooter = `
      <div id='optout-dialog-buttons-container'>
         <gz-button id='confirm'>${confirmationButtonText}</gz-button>
         <div class='flex-auto'></div>
         <gz-button id='cancel' type='outline' color='secondary'>${this.dependencies.translateFn('Cancel')}</gz-button>
      </div>
    `;

    const headline = this.dependencies.translateFn('Allow partner access to enable service.');

    return GzDialogWebComponent.computeCustomDialog(
      dialogBody,
      dialogFooter,
      headline,
      dialogCancellationCallback,
      dialogConfirmCallback,
      null,
      false
    );
  }

  private updateViewData(viewData: LicenseMainFormViewData) {
    this.viewData = viewData;

    this.setProductTypeDropdown(viewData);
    this.setAdditionalDelegableProducts(viewData);

    this.setUpReserveSeatsFormField();
    this.setUpSubscriptionEndDateFormField();
    this.setUpAutoRenewalFormField();
    this.setEnabledMinimumUsageFormField();
    this.setUpMinimumUsageFormField();
    this.setClassListOnWrapperDependingOnContext(viewData.context);
    const hasMonthlySubscription =
      viewData.companyLicenseInformation.licenseType === LicenseType.Monthly &&
      viewData.companyLicenseInformation.editedCompany.inheritedLicense;
    if (
      (viewData.context === CompanyActionContext.Edit && hasMonthlySubscription) ||
      viewData.context === CompanyActionContext.MyCompany
    ) {
      return;
    }
    this.selectFirstOwnUseBundle();
  }

  private setClassListOnWrapperDependingOnContext(context: CompanyActionContext): void {
    switch (context) {
      case CompanyActionContext.Create:
        this.dom.$wrapper.classList.add('create-context');
        break;
      case CompanyActionContext.Edit:
        this.dom.$wrapper.classList.add('update-context');
        break;
      default:
        break;
    }
  }

  public getBundlesToggleOwnUseElements(): GzToggleWebComponent[] {
    const bundlesToggle: GzToggleWebComponent[] = [];
    for (const bundleId of Object.values(Bundle)) {
      const toggle = this.dom.$ownUseBundleForm.shadowRoot?.querySelector(
        WEB_COMPONENT_GZ_RADIO + `[id="own-use-bundle-${bundleId}"]`
      ) as GzToggleWebComponent | undefined;
      if (toggle) {
        bundlesToggle[bundleId] = toggle;
      }
    }

    return bundlesToggle;
  }

  public getBundlesToggleResellElements(): GzToggleWebComponent[] {
    const bundlesToggle: GzToggleWebComponent[] = [];
    for (const bundleId of Object.values(Bundle)) {
      const toggle = this.dom.$resellBundleForm.shadowRoot?.querySelector(
        WEB_COMPONENT_GZ_TOGGLE + '[data-bundle-id="' + bundleId + '"]'
      ) as GzToggleWebComponent | undefined;
      if (toggle) {
        bundlesToggle[bundleId] = toggle;
      }
    }

    return bundlesToggle;
  }

  public selectFirstOwnUseBundle(): void {
    if (!this.dom.$ownUseBundleForm || !this.dom.$ownUseBundleForm.availableBundles) {
      return;
    }

    // select first available option
    if (Object.keys(this.dom.$ownUseBundleForm.availableBundles).length) {
      const bundlesToggle = this.getBundlesToggleResellElements();
      if (bundlesToggle.length) {
        for (const bundleToggle of Object.values(bundlesToggle)) {
          if (bundleToggle.checked) {
            bundleToggle.checked = false;
          }
        }
      }
      this.dom.$ownUseBundleForm.selectFirstOption();
    }

    this.dom.$resellBundleForm.validate();
  }

  private setProductsAndServices(companyFeatures: CompanyFeatures, companyProductServices: ProductService[]) {
    this.formGroup.value = {
      specifics: {
        features: companyFeatures,
        productServices: companyProductServices,
      },
    };

    this.dom.$ownUseProductTypeFormField.value = MonthlyProductType.getAssignedProduct(companyFeatures);

    this.dom.$ownUseMonthlyAddonsForm.value = companyFeatures;
    this.dom.$resellingMonthlyAddonsForm.value = companyFeatures;
    this.dom.$ownUseMonthlyServicesForm.value = companyFeatures;

    if (this.dom.$ownUseProductTypeFormField.value === MonthlyProductType.EndpointSecurity) {
      this.dom.$ownUseBundleForm.selectOption(getUsableBundleFeature(companyFeatures));
    }
    this.dom.$resellBundleForm.value = getResellBundleFeatures(companyFeatures);

    this.dom.$ownUseMonthlyServicesForm.productServices = companyProductServices;
    this.unsetUnavailableDelegableProducts();

    this.dom.$resellingMdrFormField.value = !!companyFeatures[FeatureFlag.PRODUCT_FEATURE_MDR_ADVICE_USABLE_DELEGATE];
  }

  buildSuccessView(data: unknown) {
    this.setDefaultValues();

    this.dom.$ownUseMonthlyAddonsForm.injectDependencies(this.dependencies);
    this.dom.$ownUseMonthlyAddonsForm.start().catch(console.error);

    this.dom.$ownUseMonthlyServicesForm.injectDependencies(this.dependencies);
    this.dom.$ownUseMonthlyServicesForm.start().catch(console.error);

    this.dom.$resellingMonthlyAddonsForm.injectDependencies(this.dependencies);
    this.dom.$resellingMonthlyAddonsForm.start().catch(console.error);
  }

  buildErrorView(error: Error) {
    return;
  }

  public updateMinCommitmentValidators() {
    this.setUpMinimumUsageFormField();
  }

  public updateAutoRenewalFormFieldAvailability() {
    this.dom.$autoRenewalFormField.disabled = !this.dom.$subscriptionEndDateFormField.isOn;
    this.dom.$autoRenewalFormField.setToggleFormValue(this.dom.$subscriptionEndDateFormField.isOn);
  }

  public updateAvailableSeatsText() {
    if (!this.dom.$reserveSeatsFormField.isOn) {
      toggleVisibility(this.dom.$availableSeatsText, false);
      return;
    }

    const maxSeats = this.getMaxSlotsToReserve();
    const reservedSeats = this.dom.$reserveSeatsFormField.value as number;

    const availableSeats = Math.max(0, maxSeats - reservedSeats);

    toggleVisibility(this.dom.$availableSeatsText, reservedSeats !== 0);

    this.dom.$availableSeatsText.textContent = this.dependencies.translateFn('({availableSeats} still available)', {
      availableSeats,
    });
  }

  private setDefaultValues() {
    // set default values
    this.dom.$reserveSeatsFormField.value = LicenseConstants.MonthlySubscription.ReserveSeats.Default;
    this.dom.$reserveSeatsFormField.setToggleFormValue(false);

    this.dom.$minimumUsageFormField.value = LicenseConstants.MonthlySubscription.MinimumUsage.Default;
    this.dom.$minimumUsageFormField.setToggleFormValue(false);
    this.dom.$minimumUsageFormField.disabledValue = LicenseConstants.MonthlySubscription.MinimumUsage.DisabledValue;

    this.dom.$subscriptionEndDateFormField.disabledValue = LicenseConstants.MonthlySubscription.EndDate.DisabledValue;

    this.dom.$autoRenewalFormField.setValueWithoutToggleUpdate(
      LicenseConstants.MonthlySubscription.AutoRenewal.Default
    );
    this.dom.$autoRenewalFormField.disabled = true;
    this.dom.$autoRenewalFormField.disabledValue = LicenseConstants.MonthlySubscription.AutoRenewal.DisabledValue;
  }

  private createFormGroup(): void {
    this.formGroup = FormGroup.build({
      specifics: {
        hasReservedSlots: new GzHardCodedFormField<boolean>(false),

        inheritedLicense: new GzHardCodedFormField<boolean>(true),

        minimalCommitment: {
          usage: {
            endpoints: this.dom.$minimumUsageFormField,
          },
        },

        license: {
          total: this.dom.$reserveSeatsFormField,
          endSubscription: {
            autoRenewPeriod: this.dom.$autoRenewalFormField,
            endDate: this.dom.$subscriptionEndDateFormField,
          },
        },

        features: {
          // main product features are always being sent to the backend
          // services/addons/etc will be added dynamically to this object
          defaultProductDelegate: this.dom.$resellingProductEndpointSecurityToggle,
          companionProductDelegate: this.dom.$resellingProductBitdefenderEdrToggle,
          companionUsable: this.companionUsableToggle,
          // mdr resell is also added here
          mdrAdviceDelegate: this.mdrDelegateFormField,
        },
      },
    });
  }

  private setProductTypeDropdown(viewData: LicenseMainFormViewData): void {
    const availableProducts = getAvailableProductTypes(viewData.context, viewData.companyLicenseInformation);
    const dropdownOptions: Array<SelectOption> = [];

    for (const option of availableProducts) {
      dropdownOptions.push({
        value: option,
        title: this.stringsTranslator.getMonthlyProductType(option),
      });
    }

    this.dom.$ownUseProductTypeFormField.Input.options = dropdownOptions;

    const assignedProductType = CompanyLicenseInformation.getEditedCompanyAssignedProductType(
      viewData.companyLicenseInformation
    );

    if (availableProducts.includes(assignedProductType)) {
      this.dom.$ownUseProductTypeFormField.Input.setFormValue(assignedProductType);
    } else if (availableProducts.length > 0) {
      // Fallback for create company case, assign at least first available product for field value
      this.dom.$ownUseProductTypeFormField.Input.setFormValue(availableProducts[0]);
    }

    this.dom.$ownUseProductTypeFormField.Validators = [
      RequiredValidator(this.dependencies.translateFn('Select a product')),
      WhitelistValidator<MonthlyProductType>(
        CompanyLicenseInformation.getParentDelegableProducts(viewData.companyLicenseInformation),
        this.dependencies.translateFn('Product type is not available')
      ),
    ];

    this.dom.$ownUseProductTypeFormField.validate(true);
  }

  private setAdditionalDelegableProducts(viewData: LicenseMainFormViewData): void {
    const monthlyProductsAvailability = MonthlyProductType.getProductsAvailability(viewData.companyLicenseInformation);

    // show/hide products based on what products the parent can delegate and what product type the child has assigned
    const canDelegateEndpointSecurity = monthlyProductsAvailability[MonthlyProductType.EndpointSecurity];
    const canDelegateBitdefenderEdr = monthlyProductsAvailability[MonthlyProductType.BitdefenderEdr];

    toggleVisibility(this.dom.$resellingProductEndpointSecurityToggle, canDelegateEndpointSecurity);
    toggleVisibility(this.dom.$resellingProductBitdefenderEdrToggle, canDelegateBitdefenderEdr);
  }

  private unsetUnavailableDelegableProducts() {
    if (!this.viewData) {
      return;
    }

    const monthlyProductsAvailability = MonthlyProductType.getProductsAvailability(
      this.viewData.companyLicenseInformation
    );

    const canDelegateEndpointSecurity = monthlyProductsAvailability[MonthlyProductType.EndpointSecurity];
    const canDelegateBitdefenderEdr = monthlyProductsAvailability[MonthlyProductType.BitdefenderEdr];

    if (!canDelegateEndpointSecurity) {
      this.dom.$resellingProductEndpointSecurityToggle.value = false;
    }

    if (!canDelegateBitdefenderEdr) {
      this.dom.$resellingProductBitdefenderEdrToggle.value = false;
    }
  }

  private setUpReserveSeatsFormField(): void {
    const minSlotsToReserve = this.getMinSlotsToReserve();
    const maxSlotsToReserve = this.getMaxSlotsToReserve();

    if (!maxSlotsToReserve) {
      this.dom.$reserveSeatsFormField.setEnabled(false);
      return;
    }

    this.dom.$reserveSeatsFormField.setEnabled(true);

    this.dom.$reserveSeatsFormField.Validators = [
      RequiredValidator(this.commonStrings.requiredField),
      MinValidator(
        minSlotsToReserve,
        this.dependencies.translateFn('The minimum value for this field is {minSlotsToReserve}', {
          minSlotsToReserve,
        })
      ),
      MaxValidator(
        maxSlotsToReserve,
        this.dependencies.translateFn('The maximum value for this field is {maxValue}', { maxValue: maxSlotsToReserve })
      ),
    ];

    this.dom.$reserveSeatsFormField.Input.min = LicenseConstants.MonthlySubscription.ReserveSeats.MinInput;
  }

  private setUpSubscriptionEndDateFormField() {
    const timezone = this.dependencies.getTimezone();
    this.dom.$subscriptionEndDateFormField.Validators = [
      // RequiredValidator would not work because it will give 'valid' result for value 0
      MinValidator(1, this.commonStrings.requiredField),
    ];

    this.dom.$subscriptionEndDateFormField.Input.menuPosition =
      this.viewData?.context === CompanyActionContext.Edit ? MenuPosition.RIGHT : MenuPosition.LEFT;

    this.dom.$subscriptionEndDateFormField.Input.pickerStrings = {
      currentDay: this.dependencies.translateFn('Today'),
    };

    this.dom.$subscriptionEndDateFormField.Input.timezone = timezone;
    this.dom.$subscriptionEndDateFormField.Input.min = getSubscriptionFormEndDateMinValue(timezone);
    this.dom.$subscriptionEndDateFormField.Input.max = 0;

    if (!this.viewData?.companyLicenseInformation.parentEndSubscriptionEndDateLimit) {
      return;
    }

    const maxSubscriptionEndDate = moment(this.viewData.companyLicenseInformation.parentEndSubscriptionEndDateLimit)
      .tz(timezone)
      .format();

    this.dom.$subscriptionEndDateFormField.Input.max = moment(maxSubscriptionEndDate).format('X');
  }

  private setUpAutoRenewalFormField() {
    this.dom.$autoRenewalFormField.Validators = [
      RequiredValidator(this.commonStrings.requiredField),
      MinValidator(
        LicenseConstants.MonthlySubscription.AutoRenewal.MinValidator,
        this.dependencies.translateFn('The minimum value for this field is {minValue}', {
          minValue: LicenseConstants.MonthlySubscription.AutoRenewal.MinValidator,
        })
      ),
      MaxValidator(
        LicenseConstants.MonthlySubscription.AutoRenewal.MaxValue,
        this.dependencies.translateFn('The maximum value for this field is {maxValue}', {
          maxValue: LicenseConstants.MonthlySubscription.AutoRenewal.MaxValue,
        })
      ),
    ];

    this.dom.$autoRenewalFormField.Input.min = LicenseConstants.MonthlySubscription.AutoRenewal.MinInput;
  }

  private setEnabledMinimumUsageFormField(): void {
    const shouldDisableMinUsage = this.viewData?.companyLicenseInformation.maxSlotsToReserve === 0;
    this.dom.$minimumUsageFormField.disabled = shouldDisableMinUsage;
  }

  private setUpMinimumUsageFormField(): void {
    const maxUsage = this.dom.$reserveSeatsFormField.isOn
      ? this.dom.$reserveSeatsFormField.value
      : this.getMaxSlotsToReserve();

    const validators = [
      RequiredValidator(this.commonStrings.requiredField),
      MinValidator(
        LicenseConstants.MonthlySubscription.MinimumUsage.MinValidator,
        this.dependencies.translateFn('The minimum value for this field is {minValue}', {
          minValue: LicenseConstants.MonthlySubscription.MinimumUsage.MinValidator,
        })
      ),
    ];

    if (maxUsage) {
      validators.push(
        MaxValidator(
          maxUsage,
          this.dependencies.translateFn(
            'Number of license seats exceeded. Enter a value lower than or equal to: {maxUsage}',
            {
              maxUsage,
            }
          )
        )
      );
    }

    this.dom.$minimumUsageFormField.Validators = validators;

    this.dom.$minimumUsageFormField.Input.min = LicenseConstants.MonthlySubscription.MinimumUsage.MinInput;
  }

  private getMinSlotsToReserve() {
    if (!this.viewData?.companyLicenseInformation.reservationSupported) {
      return LicenseConstants.MonthlySubscription.ReserveSeats.MinValidator;
    }

    const minSlotsToReserve = this.viewData.companyLicenseInformation.minSlotsToReserve;
    if (typeof minSlotsToReserve !== 'number' || minSlotsToReserve <= 0) {
      return LicenseConstants.MonthlySubscription.ReserveSeats.MinValidator;
    }

    return minSlotsToReserve;
  }

  private getMaxSlotsToReserve() {
    if (!this.viewData?.companyLicenseInformation.reservationSupported) {
      return 0;
    }

    const maxSlotsToReserve = this.viewData.companyLicenseInformation.maxSlotsToReserve;
    if (typeof maxSlotsToReserve !== 'number') {
      return 0;
    }

    return maxSlotsToReserve;
  }

  public updateReservedSeatsFormFieldAvailability(reservedSeatsToggleIsOn: boolean) {
    this.dom.$reserveSeatsFormField.disabled = !reservedSeatsToggleIsOn;
    this.dom.$reserveSeatsFormField.setToggleFormValue(reservedSeatsToggleIsOn);
  }

  public setAgreeRemoveReservedSlotsForChildren(agreeRemoveReservedSlotsForChildren: boolean) {
    this.agreeRemoveReservedSlotsForChildren = agreeRemoveReservedSlotsForChildren;
  }
}
